import { TypeMovement } from '../../interfaces'
import {
  GET_TYPE_MOVEMENTS_EXITO,
  GET_TYPE_MOVEMENTS
} from '../types/typeMovementActionTypes'

export type TypeMovementAction = TypeMovementsAction | TypeMovementsActionAsync

// Esto va a REDUX
export interface TypeMovementsAction {
  type: typeof GET_TYPE_MOVEMENTS_EXITO
  typeMovements: TypeMovement[] | undefined
  error: string | undefined
}

export const getTypeMovementsAction = (
  typeMovements: TypeMovement[],
  error?: string
): TypeMovementAction => {
  return {
    type: GET_TYPE_MOVEMENTS_EXITO,
    typeMovements,
    error
  }
}

// Esto va a SAGA
export interface TypeMovementsActionAsync {
  type: typeof GET_TYPE_MOVEMENTS
}

export const getTypeMovementsActionAsync = (): TypeMovementsActionAsync => {
  return {
    type: GET_TYPE_MOVEMENTS
  }
}
